import { render, staticRenderFns } from "./ProduitDetails.vue?vue&type=template&id=d302393e&scoped=true&"
import script from "./ProduitDetails.vue?vue&type=script&lang=js&"
export * from "./ProduitDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProduitDetails.vue?vue&type=style&index=0&id=d302393e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d302393e",
  null
  
)

export default component.exports